import { render, staticRenderFns } from "./event.pc.vue?vue&type=template&id=61fc466e&scoped=true&"
import script from "./event.pc.vue?vue&type=script&lang=js&"
export * from "./event.pc.vue?vue&type=script&lang=js&"
import style0 from "./event.pc.vue?vue&type=style&index=0&id=61fc466e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc466e",
  null
  
)

export default component.exports